import html2canvas from 'html2canvas'

export async function saveElementAsImage(element, filename = '下单详情.png') {
  if (!element) {
    throw new Error('element is required')
  }
  const canvas = await html2canvas(element, {
    backgroundColor: '#ffffff',
    scale: 2,
    useCORS: true,
    allowTaint: false,
    logging: false,
  })
  const link = document.createElement('a')
  link.download = filename
  link.href = canvas.toDataURL('image/png')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
